<template>
  <div>
    <b-card>
      <b-row class="mt-5 ml-50">
        <b-col cols="12" class="">
          <b-row>
            <b-col cols="5">
              <b-form-input v-model="search" class="d-inline-block round" placeholder="Type here..." />
            </b-col>
            <b-col cols="7">
              <b-button variant="primary" :disabled="isNew || isEdit" @click="newSchedule"
                class="btn-sm float-right mb-1">
                <feather-icon icon="PlusIcon" /> New Schedule
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-col cols="12" class="mt-2">
        <validation-observer ref="requestSubmit">
          <vue-good-table ref="my-table" :columns="columns" :key="tableDataKey" :rows="items" :pagination-options="{
            enabled: true,
            dropdownAllowAll: false,
          }" mode="remote" :sort-options="{ enabled: false }" @on-page-change="onPageChange"
            @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange">
            <template slot="table-row" slot-scope="props">
              <div class="test-container" @contextmenu.prevent="onClickRightOpenMenu($event, props)">

                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                  <span class="d-flex justify-content-center" style="gap: 10px">
                    <b-button variant="warning" size="sm" class="btn"
                      v-if="props.index != currentIndex && (!isNew || !isEdit)" v-b-tooltip.hover.top="'Edit'"
                      :disabled="isNew" @click="onRowEdit(props)">
                      <feather-icon icon="EditIcon" />
                    </b-button>
                    <b-button variant="primary" size="sm" class="btn"
                      v-if="props.index == currentIndex && (isEdit || isNew)" v-b-tooltip.hover.top="'Save as'"
                      @click="onRowSave(props)">
                      <feather-icon icon="SaveIcon" />
                    </b-button>

                    <b-button variant="secondary" size="sm" class="btn" v-if="props.index == currentIndex"
                      v-b-tooltip.hover.top="'Cancel'" @click="onCancel(props)">
                      <feather-icon icon="XIcon" />
                    </b-button>
                  </span>
                </span>

                <span v-else-if="props.column.field === 'service_type_id'">
                  <div v-if="props.index == currentIndex && (isEdit || isNew)">
                    <validation-provider name="Service Type" #default="{ errors }" rules="">
                      <b-form-group class="m-0">
                        <Select2 :class="errors.length > 0 ? 'is-invalid' : null" placeholder="Service" @select="
                          ({ name }) =>
                          (items[props.index][
                            typeName[[props.column.field]]
                          ] = name)
                        " v-model="items[props.index][props.column.field]" :options="service_types" />
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <span v-else>
                    {{ items[props.index][typeName[[props.column.field]]] }}
                  </span>
                </span>
                <span v-else-if="props.column.field === 'pol_code'">
                  <div v-if="props.index == currentIndex && (isEdit || isNew)">
                    <validation-provider name="POL" #default="{ errors }" rules="">
                      <b-form-group class="m-0">
                        <Select4 v-model="items[props.index][props.column.field]" @select="
                          ({ name }) =>
                          (items[props.index][
                            typeName[[props.column.field]]
                          ] = name)
                        " :class="errors.length > 0 ? 'is-invalid' : null" placeholder="POL" :options="{
                          isSearch: true,
  width: '600px',
  value: 'code',
  label: 'name',
  data: ports,
  fields: [
    { field: 'code', label: 'Code' },
    { field: 'name', label: 'Name' },
    { field: 'type', label: 'Service' },
    {
      field: 'country_code',
      label: 'Country Code',
    },
  ],
}" />
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <span v-else>
                    {{ items[props.index][typeName[[props.column.field]]] }}
                  </span>
                </span>
                <span v-else-if="props.column.field === 'pod_code'">
                  <div v-if="props.index == currentIndex && (isEdit || isNew)">
                    <validation-provider name="POD" #default="{ errors }" rules="">
                      <b-form-group class="m-0">
                        <Select4 v-model="items[props.index][props.column.field]" @select="
                          ({ name }) =>
                          (items[props.index][
                            typeName[[props.column.field]]
                          ] = name)
                        " :class="errors.length > 0 ? 'is-invalid' : null" placeholder="POD" :options="{
                          isSearch: true,
                          isSearch: true,
  width: '600px',
  value: 'code',
  label: 'name',
  data: ports,
  fields: [
    { field: 'code', label: 'Code' },
    { field: 'name', label: 'Name' },
    { field: 'type', label: 'Service' },
    {
      field: 'country_code',
      label: 'Country Code',
    },
  ],
}" />
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <span v-else>
                    {{ items[props.index][typeName[[props.column.field]]] }}
                  </span>
                </span>
                <span v-else-if="props.column.field === 'carrier_id'">
                  <div v-if="props.index == currentIndex && (isEdit || isNew)">
                    <validation-provider name="Carrier" #default="{ errors }" rules="">
                      <b-form-group class="m-0">
<!-- {{ shipping_lines }} -->

                        <Select4 v-model="items[props.index][props.column.field]"
                          :class="[errors.length > 0 ? 'is-invalid' : null]" placeholder="Carrier" @select="
                            ({ name }) =>
                            (items[props.index][
                              typeName[[props.column.field]]
                            ] = name)
                          " :options="{
                            isSearch: true,
  width: '600px',
  value: 'id',
  label: 'code',
  data: shipping_lines,
  fields: [
    { field: 'code', label: 'Code' },
    { field: 'name', label: 'Shipping Line' },
  ],
}" />
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <span v-else>
                    {{ getCarrierCodeById(items[props.index][props.column.field]) }}
                  </span>
                </span>
                <!-- load_vessel_id -->
                <span v-else-if="props.column.field === 'load_vessel'">
                  <div v-if="props.index == currentIndex && (isEdit || isNew)">
                    <validation-provider name="Load Vessel" #default="{ errors }" rules="">
                      <b-form-group class="m-0">
                        <!-- <Select4 v-model="items[props.index][props.column.field]"
                          :class="[errors.length > 0 ? 'is-invalid' : null]" class="input-sec" style="
                          position: relative;
                          flex: 1 1 auto;
                          min-width: 0;
                          border-top-left-radius: 0;
                          border-bottom-left-radius: 0;
                        " placeholder="Choose Load Vessel" @select="
                          ({ name }) =>
                          (items[props.index][
                            typeName[[props.column.field]]
                          ] = name)
                        " :options="{
                          width: '600px',

                          value: 'id',
                          label: 'name',
                          data: vessel,
                          hide: true,
                          fields: [{ field: 'name', label: 'Name' }],
                        }" /> -->
                        <b-form-input :state="errors.length > 0 ? false : null" placeholder="Load Vessel"
                          v-model="items[props.index][props.column.field]" type="text"></b-form-input>
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <span v-else>
                    {{ items[props.index][typeName[[props.column.field]]] }}
                  </span>
                </span>
                <!-- discharge_vessel_id -->
                <span v-else-if="props.column.field === 'discharge_vessel'">
                  <div v-if="props.index == currentIndex && (isEdit || isNew)">
                    <validation-provider name="Discharge Vessel" #default="{ errors }" rules="">
                      <b-form-group class="m-0">
                        <!-- <Select4 v-model="items[props.index][props.column.field]" @select="
                          ({ name }) =>
                          (items[props.index][
                            typeName[[props.column.field]]
                          ] = name)
                        " :class="[errors.length > 0 ? 'is-invalid' : null]" class="input-sec" style="
                          position: relative;
                          flex: 1 1 auto;
                          min-width: 0;
                          border-top-left-radius: 0;
                          border-bottom-left-radius: 0;
                        " placeholder="Choose Discharge Vessel" :options="{
                          width: '600px',
                        
                          value: 'id',
                          label: 'name',
                          data: vessel,
                          hide: true,
                          fields: [{ field: 'name', label: 'Name' }],
                        }" /> -->
                        <b-form-input :state="errors.length > 0 ? false : null" placeholder="Discharge Vessel"
                          v-model="items[props.index][props.column.field]" type="text"></b-form-input>
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <span v-else>
                    {{ items[props.index][typeName[[props.column.field]]] }}
                  </span>
                </span>

                <span v-else-if="props.column.field === 'etd'">
                  <div v-if="props.index == currentIndex && (isEdit || isNew)">
                    <validation-provider #default="{ errors }" rules="">
                      <b-form-group class="m-0">
                        <date-picker ref="datePicker" v-model="items[props.index][props.column.field]" type="date"
                          :title="items[props.index][props.column.field]" class="w-full"
                          :class="errors.length > 0 ? 'is-invalid' : null" value-type="format" title-format="DD/MM/YY"
                          time-title-format="DD/MM/YY" placeholder="Select date" :show-time-panel="showTimePanel"
                          format="DD/MM/YY" @close="handleOpenChange">
                        </date-picker>
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </span>

                <span v-else-if="props.column.field === 'eta'">
                  <div v-if="props.index == currentIndex && (isEdit || isNew)">
                    <validation-provider #default="{ errors }" rules="">
                      <b-form-group class="m-0">
                        <date-picker ref="datePicker" v-model="items[props.index][props.column.field]" type="date"
                          :title="items[props.index][props.column.field]" class="w-full"
                          :class="errors.length > 0 ? 'is-invalid' : null" value-type="format" title-format="DD/MM/YY"
                          time-title-format="DD/MM/YY" placeholder="Select date" :show-time-panel="showTimePanel"
                          format="DD/MM/YY" @close="handleOpenChange">
                        </date-picker>
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </span>

                <span v-else-if="props.column.field === 'transit_code'">
                  <div v-if="props.index == currentIndex && (isEdit || isNew)">
                    <validation-provider #default="{ errors }" rules="">
                      <b-form-group class="m-0">
                        <Select4 v-model="items[props.index][props.column.field]" @select="
                          ({ name }) =>
                          (items[props.index][
                            typeName[[props.column.field]]
                          ] = name)
                        " :class="errors.length > 0 ? 'is-invalid' : null" placeholder="POD" :options="{
                          isSearch: true,
  width: '600px',
  value: 'code',
  label: 'name',
  data: ports,
  fields: [
    { field: 'code', label: 'Code' },
    { field: 'name', label: 'Name' },
    { field: 'type', label: 'Service' },
    {
      field: 'country_code',
      label: 'Country Code',
    },
  ],
}" />
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <span v-else>
                    {{ items[props.index][typeName[[props.column.field]]] }}
                  </span>
                </span>
                <span v-else-if="props.column.field === 'transit_time'">
                  <div v-if="props.index == currentIndex && (isEdit || isNew)">
                    <validation-provider name="TRANSIT TIME" #default="{ errors }" rules="">
                      <b-form-group class="m-0">
                        <b-form-input :state="errors.length > 0 ? false : null" placeholder="TRANSIT TIME"
                          v-model="items[props.index][props.column.field]" type="text"></b-form-input>
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </span>

                <span v-else-if="props.column.field === 'cargo_cut_off'">
                  <div v-if="props.index == currentIndex && (isEdit || isNew)">
                    <validation-provider name="Cargo Cut Off" #default="{ errors }" rules="">
                      <b-form-group class="m-0">
                        <date-picker ref="datePicker" v-model="items[props.index][props.column.field]" type="datetime"
                          class="w-full" :title="items[props.index][props.column.field]"
                          :class="errors.length > 0 ? 'is-invalid' : null" value-type="format" title-format="DD/MM/YY"
                          time-title-format="DD/MM/YY" placeholder="Select datetime" :show-time-panel="showTimePanel"
                          format="DD/MM/YY HH:mm" @close="handleOpenChange">
                          <template v-slot:footer>
                            <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                              {{ showTimePanel ? "Date" : "Time" }}
                            </button>
                          </template>
                        </date-picker>
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </span>

                <span v-else-if="props.column.field === 'doc_cut_off'">
                  <div v-if="props.index == currentIndex && (isEdit || isNew)">
                    <validation-provider name="Doc Cut Off" #default="{ errors }" rules="">
                      <b-form-group class="m-0">
                        <date-picker ref="datePicker" v-model="items[props.index][props.column.field]" type="datetime"
                          class="w-full" :title="items[props.index][props.column.field]"
                          :class="errors.length > 0 ? 'is-invalid' : null" value-type="format" title-format="DD/MM/YY"
                          time-title-format="DD/MM/YY" placeholder="Select datetime" :show-time-panel="showTimePanel"
                          format="DD/MM/YY HH:mm" @close="handleOpenChange">
                          <template v-slot:footer>
                            <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                              {{ showTimePanel ? "Date" : "Time" }}
                            </button>
                          </template>
                        </date-picker>
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </span>

                <span v-else-if="props.column.field === 'stuffing_place_id'">
                  <div v-if="props.index == currentIndex && (isEdit || isNew)">
                    <validation-provider name="Stuffing Place " #default="{ errors }" rules="">
                      <b-form-group class="m-0">
                        <Select4 v-model="items[props.index][props.column.field]" @select="
                          ({ name }) =>
                          (items[props.index][
                            typeName[[props.column.field]]
                          ] = name)
                        " :class="errors.length > 0 ? 'is-invalid' : null" placeholder="Enter Stuffing Place "
                          :options="{
                            isSearch: true,
                            width: '600px',
                            left: '200px',
                            value: 'id',
                            label: 'abbreviations',
                            data: locations,
                            fields: [
                              { field: 'abbreviations', label: 'Abbreviations' },
                              { field: 'name', label: 'Location' },
                              {
                                field: 'address',
                                label: 'Address',
                              },
                            ],
                          }" />
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <span v-else>
                    {{ items[props.index][typeName[[props.column.field]]] }}
                  </span>
                </span>

                <span v-else-if="props.column.field === 'contact'">
                  <div v-if="props.index == currentIndex && (isEdit || isNew)">
                    <validation-provider name="CONTACT" #default="{ errors }" rules="">
                      <b-form-group class="m-0">
                        <b-form-input :state="errors.length > 0 ? false : null" placeholder="CONTACT"
                          v-model="items[props.index][props.column.field]" type="text"></b-form-input>
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </span>
                <!-- Column: Common -->

              </div>

            </template>


            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="">
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap"> {{ $t("showing") }} </span>
                  <b-form-select v-model="pageSize" :options="['10', '50', '100']" class="mx-1"
                    @input="(value) => onPerPageChange(value)" />
                  <span class="text-nowrap">
                    {{ $t("entries") }}
                  </span>
                </div>
                <div>
                  <b-pagination :value="page" :total-rows="totalRecords" :per-page="pageSize" first-number last-number
                    @click="tableDataKey++" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="
                      (value) => {
                        return onPageChange(value);
                      }
                    ">
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </div>
            </template>

          </vue-good-table>


        </validation-observer>
      </b-col>
      <ul class="menuu" ref="menuRightScheduleList">
        <li class="li-i" @click="onHandleEdit">
          <feather-icon icon="EditIcon" class="mr-50" />
          <span>Edit</span>
        </li>

        <li class="li-i" @click="onHandleCopy">
          <feather-icon icon="CopyIcon" class="mr-50" />
          <span>Copy</span>
        </li>
      </ul>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Select2 from "v-select2-component";
import { mapState, mapActions } from "vuex";
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    Select2,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      rowSelectCopy: null,
      typeName: {
        service_type_id: "service_type",
        pol_code: "pol",
        pod_code: "pod",
        carrier_id: "carrier",
        load_vessel: "load_vessel",
        discharge_vessel: "discharge_vessel",
        transit_code: "transit",
        stuffing_place_id: "stuffing_place",
        etd: "etd",
        eta: "eta",
      },
      tableDataKey: 1,
      isEdit: false,
      isNew: false,
      showTimeRangePanel: false,
      currentIndex: null,
      search: null,
      currentItem: {},
      totalRecords: 0,
      showTimePanel: false,
      currentItemTemp: {},
      columnFilters: {},

      columns: [
        {
          label: "Service",
          thClass: "text-uppercase align-middle",
          tdClass: "align-middle",
          field: "service_type_id",
          filterOptions: {
            enabled: true,
            placeholder: "Service",
          },
        },
        {
          label: "POL",
          thClass: "text-uppercase align-middle",
          field: "pol_code",
          tdClass: "align-middle",

          filterOptions: {
            enabled: true,
            placeholder: "POL",
          },
        },
        {
          label: "POD",
          field: "pod_code",
          thClass: "text-uppercase align-middle",

          filterOptions: {
            enabled: true,
            placeholder: "POD",
          },
        },
        {
          label: "CARRIER",
          thClass: "text-uppercase align-middle",
          field: "carrier_id",
          tdClass: "align-middle",

          filterOptions: {
            enabled: true,
            placeholder: "CARRIER",
          },
        },
        {
          label: "Load Vessel",
          tdClass: "align-middle",

          thClass: "text-uppercase align-middle",
          field: "load_vessel",
          filterOptions: {
            enabled: true,
            placeholder: "Load Vessel",
          },
        },
        {
          label: "Discharge Vessel",
          tdClass: "align-middle",

          thClass: "text-uppercase align-middle",
          field: "discharge_vessel",
          filterOptions: {
            enabled: true,
            placeholder: "Discharge Vessel",
          },
        },
        {
          label: "ETD",
          tdClass: "align-middle",

          thClass: "text-uppercase align-middle",
          field: "etd",
          filterOptions: {
            enabled: true,
            placeholder: "ETD",
          },
        },
        {
          label: "ETA",
          tdClass: "align-middle",

          thClass: "text-uppercase align-middle",
          field: "eta",
          filterOptions: {
            enabled: true,
            placeholder: "ETA",
          },
        },
        {
          label: "TRANSIT PORT",
          tdClass: "align-middle",

          field: "transit_code",
          thClass: "text-uppercase align-middle",

          filterOptions: {
            enabled: true,
            placeholder: "TRANSIT PORT",
          },
        },
        {
          label: "TRANSIT TIME",
          tdClass: "align-middle",

          field: "transit_time",
          thClass: "text-uppercase align-middle",

          filterOptions: {
            enabled: true,
            placeholder: "TRANSIT TIME",
          },
        },
        {
          label: "CARGO CUT OFF",
          tdClass: "align-middle",

          field: "cargo_cut_off",
          thClass: "text-uppercase align-middle",

          filterOptions: {
            enabled: true,
            placeholder: "CARGO CUT OFF",
          },
        },
        {
          label: "DOC CUT OFF",
          tdClass: "align-middle",

          field: "doc_cut_off",
          thClass: "text-uppercase align-middle",

          filterOptions: {
            enabled: true,
            placeholder: "DOC CUT OFF",
          },
        },

        {
          label: "STUFFING PLACE",
          tdClass: "align-middle",

          thClass: "text-uppercase align-middle",
          field: "stuffing_place_id",
          width: "200px",
          filterOptions: {
            enabled: true,
            placeholder: "STUFFING PLACE",
          },
        },
        {
          label: "CONTACT",
          tdClass: "align-middle",
          thClass: "text-uppercase align-middle",
          field: "contact",
          width: "200px",
          filterOptions: {
            enabled: true,
            placeholder: "CONTACT",
          },
        },

        {
          thClass: "text-uppercase align-middle",
          label: "Action",
          tdClass: "align-middle ",

          field: "action",
        },
      ],
      items: [],
      page: 1,
      pageSize: 10,
      totalRecords: 0,
    };
  },
  created() {
    this.$loading.show();
    this.$store.dispatch("masterData/FETCH_ALL");
    this.loadItems();
  },
  mounted() {
    const menu = this.$refs.menuRightScheduleList;
    window.addEventListener("click", () => (menu.style.visibility = "hidden"));
  },
  watch: {
    search(n) {
      this.loadItems();
    },
  },
  computed: {
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "vessel",
      "locations",
    ]),
  },
  methods: {
    onHandleEdit() {
      const menu = this.$refs.menuRightScheduleList;

      this.currentItemTemp = { ...this.rowSelectCopy.row };
      this.currentIndex = this.rowSelectCopy.index;
      this.currentItem = this.rowSelectCopy.row;
      this.isEdit = true;
      menu.style.visibility = "hidden"
    },
    onHandleCopy() {
      // console.log('--- onHandleCopy ---', this.rowSelectCopy);
      this.$loading.show();

      const schedule_list = this.rowSelectCopy.row

      useJwt
        .put("copyScheduleList", {
          id: schedule_list.id,
          ...schedule_list

        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("bookingSaleSuccess"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          this.loadItems();
          this.$bvModal.hide("new-booking-note");
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("bookingSaleError"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());

    },

    onClickRightOpenMenu(e, row) {
      // console.log(e);
      // console.log(row);

     
      e.preventDefault();

      this.rowSelectCopy = row

      const menu = this.$refs.menuRightScheduleList,
        menuWidth = menu.offsetWidth,
        menuHeight = menu.offsetHeight,
        card = this.$refs.card;

      let x = e.layerX + 20,
        y = e.layerY + 120,
        winWidth = window.innerWidth,
        winHeight = window.innerHeight;
      //   x = x > winWidth - menuWidth ? winWidth - menuWidth - 5 : x;
      // y = y > winHeight - menuHeight ? winHeight - menuHeight - 5 : y;

      menu.style.left = `${x}px`;
      menu.style.top = `${y}px`;
      menu.style.visibility = "visible";
    },
    getCarrierCodeById(payload) {
      return this.shipping_lines.filter(e => e.id == payload)[0]?.code || ""
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleCloseChange() {
      this.$refs.datePicker.popupVisible = false;
    },

    handleOpenChange() {
      this.showTimePanel = false;
    },
    onRowEdit(payload) {
      this.currentItemTemp = { ...payload.row };
      this.currentIndex = payload.index;
      this.currentItem = payload.row;
      this.isEdit = true;
    },
    resetForm() {
      this.pageSize = 10;
      this.page = 1;
      this.isEdit = false;
      this.isNew = false;
      this.currentIndex = null;
      this.currentItem = null;
    },
    onPerPageChange(params) {
      this.$loading.show();
      this.pageSize = params;
      this.page = 1;
      this.loadItems();
      this.$refs["my-table"].reset();
    },
    onPageChange(params) {
      this.$loading.show();
      this.page = params;
      this.loadItems();
    },

    loadItems() {
      useJwt
        .get("scheduleList", {
          params: {
            search: { keyword: this.search, ...this.columnFilters },
            page: this.page,
            pageSize: this.pageSize,
          },
        })
        .then((response) => {
          this.items = response.data.result;
          this.totalRecords = response.data.meta.total;
        })
        .finally(() => this.$loading.hide());
    },
    async onRowSave(payload) {
      var validate = await this.$refs.requestSubmit
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      if (this.isNew) {
        this.postSchedule(payload);
      } else {
        this.putSchedule(payload);
      }
    },

    postSchedule(payload) {
      this.$loading.show();

      useJwt
        .post("scheduleList", {
          ...payload.row,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("bookingSaleSuccess"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          this.resetForm()
          this.loadItems();
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("bookingSaleError"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    putSchedule(payload) {
      this.$loading.show();
      useJwt
        .put("scheduleList", {
          ...payload.row,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("bookingSaleSuccess"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          this.loadItems();
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("bookingSaleError"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },

    onColumnFilter(params) {
      const { columnFilters } = params;
      var vm = this;
      vm.columnFilters = {};
      Object.keys(columnFilters).forEach((key) => {
        vm.typeName[key]
          ? (vm.columnFilters[this.typeName[key]] = columnFilters[key])
          : (vm.columnFilters[key] = columnFilters[key]);
      });
      this.loadItems();
    },
    onCancel() {
      if (this.isNew) {
        this.items.shift();
        this.currentIndex = null;
        this.isNew = false;
      } else {
        this.items[this.currentIndex] = { ...this.currentItemTemp };
        this.currentItemTemp = null;
        this.currentIndex = null;

        this.isEdit = false;
      }
    },
    newSchedule() {
      this.items.unshift({});
      this.currentIndex = 0;
      this.isNew = true;
      this.tableDataKey++;
    },
  },
};
</script>
<style lang="scss" >
.select2-container--default .select2-selection--single {
  border: 1px solid #d8d6de;
}

.select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=") center / contain no-repeat;
}

.is-invalid .select2-selection--single {
  border: 1px solid #ea5455;
}

.is-invalid .select2-selection--single::before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ea5455' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ea5455' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
}

.select2-selection__arrow {
  background: none;
  display: none !important;
}

.vgt-table th {
  padding: 0.75em 1.5em 0.75em 0.75em;
}

.vgt-table td,
.vgt-table th {
  vertical-align: middle !important;
  font-size: 1rem;
}
</style>